// Used to prevent circle dependency.

export const wrapperWidth = '80rem';
export const wrapperWidthSxga = '90rem';
export const wrapperWidthWxgaPlus = '110rem';
export const wrapperWidthWuxga = '120rem';
